import { CheckCircle2, CircleAlert, Info, TriangleAlert, X } from "lucide-react";
import {
  useCallback,
  useMemo,
  useState,
  type ReactNode,
} from "react";
import { IconButton } from "./controls";
import { ToastContext, type ToastInput } from "./toast-context";

type ToastRecord = ToastInput & { id: string };

export function ToastProvider({ children }: { children: ReactNode }) {
  const [toasts, setToasts] = useState<ToastRecord[]>([]);
  const dismiss = useCallback((id: string) => {
    setToasts((current) => current.filter((toast) => toast.id !== id));
  }, []);
  const notify = useCallback((input: ToastInput) => {
    const id = crypto.randomUUID();
    setToasts((current) => {
      const remaining = input.replaceKey
        ? current.filter((toast) => toast.replaceKey !== input.replaceKey)
        : current;
      return [{ ...input, id }, ...remaining].slice(0, 4);
    });
    window.setTimeout(() => dismiss(id), 5000);
  }, [dismiss]);
  const context = useMemo(() => notify, [notify]);
  return (
    <ToastContext.Provider value={context}>
      {children}
      <div className="ui-toast-region" role="region" aria-live="polite" aria-label="Bildirimler">
        {toasts.map((toast) => {
          const Icon = toast.tone === "success"
            ? CheckCircle2
            : toast.tone === "danger"
              ? CircleAlert
              : toast.tone === "warning"
                ? TriangleAlert
                : Info;
          return (
            <article
              className={`ui-toast ui-toast-${toast.tone ?? "info"}`}
              key={toast.id}
              role={toast.tone === "danger" ? "alert" : "status"}
            >
              <span className="ui-toast-icon" aria-hidden="true"><Icon size={18} /></span>
              <div className="ui-toast-copy"><strong>{toast.title}</strong>{toast.description && <p>{toast.description}</p>}</div>
              <IconButton label="Bildirimi kapat" variant="ghost" onClick={() => dismiss(toast.id)}><X size={15} strokeWidth={1.8} /></IconButton>
            </article>
          );
        })}
      </div>
    </ToastContext.Provider>
  );
}
